import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import DataLoader from 'dataloader';
import { Store } from 'libx';
import env from '../misc/env';
import { createIamAPI } from './API';
import memoize from 'memoizee';
import TeamMember from './TeamMember';

/**
 * Team Member Store.
 */
var TeamMemberStore = /*#__PURE__*/function (_Store) {
  function TeamMemberStore() {
    var _this;
    _classCallCheck(this, TeamMemberStore);
    _this = _callSuper(this, TeamMemberStore, arguments);
    /**
     * Team Members collection.
     */
    _this.teamMembers = _this.collection({
      model: TeamMember,
      // We don't use the TeamMember `id` for anything, always team + user ID.
      getDataId: function getDataId(data) {
        return "".concat(data.team_id, "/").concat(data.user_id);
      },
      getModelId: function getModelId(model) {
        return "".concat(model.teamId, "/").concat(model.userId);
      }
    });
    /**
     * IAM API.
     */
    _this.api = createIamAPI({
      baseURL: env.IAM_API,
      getToken: _this.rootStore.authStore.getToken
    });
    /**
     * Team member cache.
     */
    _this.teamMemberCacheMap = new Map();
    /**
     * Cache key function.
     */
    _this._cacheKeyFn = function (id) {
      return "".concat(id.workspace_id, "/").concat(id.user_id, "/").concat(id.include_team);
    };
    /**
     * Team member loader.
     */
    _this.teamMemberLoader = new DataLoader(_this._fetchMany.bind(_this), {
      cacheMap: _this.teamMemberCacheMap,
      cacheKeyFn: _this._cacheKeyFn
    });
    _this.teamMemberLoaderByPublicId = new DataLoader(_this._fetchManyByPublicId.bind(_this), {
      cacheMap: _this.teamMemberCacheMap,
      cacheKeyFn: _this._cacheKeyFn
    });
    _this.fetchUserTeamMembersByPublicId = memoize(_this.fetchUserTeamMembersByPublicId.bind(_this), {
      promise: true,
      length: 1,
      normalizer: function normalizer(args) {
        var params = args[0] || {};
        return "".concat(params.workspace_id, "/").concat(params.user_id);
      }
    });
    _this.rootStore.sessionStore.onWorkspaceSelected(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.teamMembers.clear();
            _this.fetchUserTeamMembersByPublicId.clear();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return _this;
  }
  _inherits(TeamMemberStore, _Store);
  return _createClass(TeamMemberStore, [{
    key: "teamMembersForWorkspaceMemberByPublicId",
    value: function teamMembersForWorkspaceMemberByPublicId(workspaceId, userPublicId) {
      var sessionStore = this.rootStore.sessionStore;
      workspaceId = workspaceId || sessionStore.workspace.id;
      userPublicId = userPublicId || sessionStore.user.public_id;
      return this.teamMembers.filter(function (x) {
        return x.userPublicId === userPublicId && x.workspaceId === workspaceId;
      });
    }

    /**
     * Gets a local team member by team and user ID.
     *
     * @param {*} teamId
     * @param {*} userId
     */
  }, {
    key: "forTeamAndUser",
    value: function forTeamAndUser(teamId, userId) {
      return this.teamMembers.find(function (x) {
        return x.teamId === teamId && x.userId === userId;
      }) || null;
    }
  }, {
    key: "forTeamAndUserByPublicId",
    value: function forTeamAndUserByPublicId(teamId, userPublicId) {
      return this.teamMembers.find(function (x) {
        return x.teamId === teamId && x.userPublicId === userPublicId;
      }) || null;
    }

    /**
     * Gets local team members by team ID.
     *
     * @param {*} teamId
     * @param {*} userId
     */
  }, {
    key: "forTeam",
    value: function forTeam(teamId) {
      return this.teamMembers.filter(function (x) {
        return x.teamId === teamId;
      });
    }

    /**
     * Fetches team memberships for the specified workspace member. Defaults to current.
     * @param {*} params
     */
  }, {
    key: "fetchUserTeamMembersByPublicId",
    value: (function () {
      var _fetchUserTeamMembersByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var params,
          sessionStore,
          result,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              sessionStore = this.rootStore.sessionStore;
              _context2.next = 4;
              return this.api.teamMembers.getTeamMembersForWorkspaceMemberByPublicId({
                workspace_id: params.workspace_id || sessionStore.workspace.id,
                user_id: params.user_id || sessionStore.user.public_id,
                include_team: true
              });
            case 4:
              result = _context2.sent;
              return _context2.abrupt("return", this.teamMembers.set(result));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchUserTeamMembersByPublicId() {
        return _fetchUserTeamMembersByPublicId.apply(this, arguments);
      }
      return fetchUserTeamMembersByPublicId;
    }()
    /**
     * Fetches a single team member.
     */
    )
  }, {
    key: "fetch",
    value: (function () {
      var _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.teamMemberLoader.load(id));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }())
  }, {
    key: "fetchByPublicId",
    value: function () {
      var _fetchByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.teamMemberLoaderByPublicId.load(id));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchByPublicId(_x2) {
        return _fetchByPublicId.apply(this, arguments);
      }
      return fetchByPublicId;
    }()
    /**
     * Fetches multiple team members.
     */
  }, {
    key: "fetchMany",
    value: (function () {
      var _fetchMany2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(ids) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.teamMemberLoader.loadMany(ids));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function fetchMany(_x3) {
        return _fetchMany2.apply(this, arguments);
      }
      return fetchMany;
    }())
  }, {
    key: "fetchManyByPublicId",
    value: function () {
      var _fetchManyByPublicId2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(ids) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.teamMemberLoaderByPublicId.loadMany(ids));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function fetchManyByPublicId(_x4) {
        return _fetchManyByPublicId2.apply(this, arguments);
      }
      return fetchManyByPublicId;
    }()
    /**
     * Queries for team members.
     *
     * @param {*} params
     */
  }, {
    key: "find",
    value: (function () {
      var _find = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(params) {
        var _this2 = this;
        var result, data;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              params.limit = 100;
              _context7.next = 3;
              return this.api.teamMembers.find(params);
            case 3:
              result = _context7.sent;
              data = this.teamMembers.set(result.data);
              data.forEach(function (m) {
                return _this2.teamMemberLoader.prime({
                  team_id: m.teamId,
                  user_id: m.userId
                }, m);
              });
              return _context7.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
                data: data
              }));
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function find(_x5) {
        return _find.apply(this, arguments);
      }
      return find;
    }()
    /**
     * Adds a workspace member to a team. Requires workspace permissions, not something
     * that a team admin can do on their own.
     *
     * @param {*} payload
     */
    )
  }, {
    key: "addTeamMember",
    value: (function () {
      var _addTeamMember = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", this.api.teamMembers.create(payload).then(this.teamMembers.set));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function addTeamMember(_x6) {
        return _addTeamMember.apply(this, arguments);
      }
      return addTeamMember;
    }()
    /**
     * Adds a workspace member to a team by public id.
     * Requires workspace permissions, not something
     * that a team admin can do on their own.
     *
     * @param {*} payload
     */
    )
  }, {
    key: "addTeamMemberByPublicId",
    value: (function () {
      var _addTeamMemberByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", this.api.teamMembers.createByPublicId(payload).then(this.teamMembers.set));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function addTeamMemberByPublicId(_x7) {
        return _addTeamMemberByPublicId.apply(this, arguments);
      }
      return addTeamMemberByPublicId;
    }()
    /**
     * Updates a team member using public id.
     *
     * @param {*} params
     * @param {*} payload
     */
    )
  }, {
    key: "updateTeamMemberByPublicId",
    value: (function () {
      var _updateTeamMemberByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params, payload) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", this.api.teamMembers.updateByPublicId(params, payload).then(this.teamMembers.set));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function updateTeamMemberByPublicId(_x8, _x9) {
        return _updateTeamMemberByPublicId.apply(this, arguments);
      }
      return updateTeamMemberByPublicId;
    }()
    /**
     * Deletes a team member using public id.
     * @param {*} params
     */
    )
  }, {
    key: "deleteTeamMemberByPublicId",
    value: (function () {
      var _deleteTeamMemberByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(params) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.api.teamMembers.deleteByPublicId(params);
            case 2:
              this.teamMembers.remove(this.forTeamAndUserByPublicId(params.team_id, params.user_id));
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function deleteTeamMemberByPublicId(_x10) {
        return _deleteTeamMemberByPublicId.apply(this, arguments);
      }
      return deleteTeamMemberByPublicId;
    }()
    /**
     * Initialize (or update), (maybe) fetch and return the model.
     *
     * @param {{ user_public_id: string, team_id: string }} props
     */
    )
  }, {
    key: "setAndFetchByPublicId",
    value: function setAndFetchByPublicId(props) {
      var _this3 = this;
      if (Array.isArray(props)) {
        return props.map(function (x) {
          return _this3.setAndFetchByPublicId(x);
        });
      }
      if (!props.team_id) {
        throw new Error('TeamMemberStore.setAndFetchByPublicId: props.team_id is required.');
      }
      if (!props.user_public_id) {
        throw new Error('TeamMemberStore.setAndFetchByPublicId: props.user_public_id is required.');
      }
      var alreadyCached = this.teamMemberCacheMap.has(this._cacheKeyFn(props));
      this.fetchByPublicId(props);
      var member = this._getOrInitMemberForParamsByPublicId(props);
      if (alreadyCached) {
        // The member has already been requested, so don't
        // assign any props to it
        return member;
      }
      return member.set(props, {
        parse: true,
        stripUndefined: true
      });
    }

    /**
     * Implementation of fetching many team members.
     *
     * @param {*} ids
     */
  }, {
    key: "_fetchMany",
    value: (function () {
      var _fetchMany3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(ids) {
        var _this4 = this;
        var result;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.api.teamMembers.getMany(ids).then(this.teamMembers.set);
            case 2:
              result = _context12.sent;
              result.forEach(function (t, i) {
                if (!t) {
                  // Just because a team was not found does not mean it will never exist.
                  _this4.teamMemberLoader.clear(ids[i]);
                }
              });
              return _context12.abrupt("return", result);
            case 5:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function _fetchMany(_x11) {
        return _fetchMany3.apply(this, arguments);
      }
      return _fetchMany;
    }()
    /**
     * Implementation of fetching many team members.
     *
     * @param {*} props
     */
    )
  }, {
    key: "_fetchManyByPublicId",
    value: (function () {
      var _fetchManyByPublicId3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(props) {
        var _this5 = this;
        var result;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.api.teamMembers.getManyByPublicId(props.map(function (prop) {
                return {
                  user_id: prop.user_public_id,
                  team_id: prop.team_id
                };
              })).then(this.teamMembers.set);
            case 2:
              result = _context13.sent;
              result.forEach(function (t, i) {
                if (!t) {
                  // Just because a team was not found does not mean it will never exist.
                  _this5.teamMemberLoaderByPublicId.clear(props[i]);
                }
              });
              return _context13.abrupt("return", result);
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function _fetchManyByPublicId(_x12) {
        return _fetchManyByPublicId3.apply(this, arguments);
      }
      return _fetchManyByPublicId;
    }())
  }, {
    key: "_getOrInitMemberForParamsByPublicId",
    value: function _getOrInitMemberForParamsByPublicId(params) {
      return params.team_id && params.user_public_id ? this.forTeamAndUserByPublicId(params.team_id, params.user_public_id) || this.teamMembers.set(params) : null;
    }
  }]);
}(Store);
export { TeamMemberStore as default };
//# sourceMappingURL=TeamMemberStore.js.map
